<template>
	<el-dialog
		title="请通过验证"
		v-if="dialogVisible"
		:visible.sync="dialogVisible"
		width="500px"
		:close-on-click-modal="false"
	>
        <VerifyCore ref="VerifyCore" @submit="submitHandler"/>

		<span slot="footer" class="dialog-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" @click="submitHandler"
				>确 定</el-button
			>
		</span>
	</el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import VerifyCore from "@/components/MFA/VerifyCore";

export default {
	components: {
		VerifyCore,
	},
	data() {
		return {
			dialogVisible: false,
			MFAs: [],
		};
	},
	computed: {
		...mapGetters(["userInfo"])
	},
	methods: {
		/**
		 * 获得可用验证方式
		 *
		 * @return  {Array}  ["sms","email"]
		 */
		getAbleVerifyType() {
			let rs = [];
			let secverifyTypeArr = this.userInfo.secverifyType?this.userInfo.secverifyType.split(","):[]
			let brandSecverifyTypeArr = this.userInfo.brandSecverifyType?this.userInfo.brandSecverifyType.split(","):[];
			for(let s of secverifyTypeArr) {
				if (brandSecverifyTypeArr.includes(s)) {
					rs.push(s)
				}
			}
			return rs;
		},


		/**
		 * [open description]
		 *
		 * @param   {[type]}  verifyType  [verifyType description]
		 * @param   {Object}  params      {
		 * 	phoneNumber //手机号
		 * 	email // 邮箱
		 *  verifySendApi //发送消息的接口
		 * }
		 *
		 * @return  {[type]}              [return description]
		 */
		open(params) {
			this.dialogVisible = true;
			this.$nextTick(() => {
				this.$refs.VerifyCore.init(this.getAbleVerifyType(), params);
			});
		},
		submitHandler() {
			let code = this.$refs.VerifyCore.getCode();
			if (!code) {
				return;
			}
			this.$emit("onSubmit", code, this.close);
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					alert("submit!");
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		close() {
			this.dialogVisible = false;
		}
	},
};
</script>

<style>
</style>